import { KatAlert } from '@amzn/katal-react';
import React from 'react';

export enum AlertType {
  INFO = 'info',
  INFO_CTA = 'info_cta',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
}

export interface IAlert extends KatAlert._OwnProps {
  type: AlertType;
  header: React.ReactNode;
  description: string;
}

const Alert: React.FC<IAlert> = ({ type, ...props }) => {
  switch (type) {
    case AlertType.SUCCESS:
      return <KatAlert variant="success" {...props} />;
    case AlertType.ERROR:
      return <KatAlert variant="danger" {...props} />;
  }
  return <></>;
};

export default Alert;
